
import Main from './pages/Main'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Forstartups from './pages/forstartups';
import Foragencies from './pages/foragencies';
import Contact from './pages/contact';




function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/forstartups" element={<Forstartups />} />
          <Route path="/foragencies" element={<Foragencies />} />
          <Route path='/Contact' element={<Contact/>}/>
        </Routes>
      </BrowserRouter>



    </div>
  )
}

export default App